import React, { Component } from 'react';
import NavBar from '../Components/NavBar/NavBar.js';
import './Servicos.css';
import FooterContatos from '../Components/Footer/FooterContatos.js';
import Footer from '../Components/Footer/Footer.js';
import ButtonE1 from "../Components/ButtonsEmpresa/coaText.js";
import ButtonE2 from "../Components/ButtonsEmpresa/coatextbutton.js";
import FloatingWhatsApp from 'react-floating-whatsapp';
import LOGOL from '../Images/logo2.png';

class Empresa extends Component {
 render() {
 return (
   <div className="bgcolor1">
   <NavBar/>
   <div className="apresentacao"><h5 className="h52"><h1 className="i2">Sobre a Centro Oeste Automação Industrial</h1></h5>
  </div>
  
  <div className="columnEMPRESA">Fundada em 2021, a Centro Oeste Automação Industrial surgiu da experiência técnica e visão empreendedora dos sócios da antiga Fluxo Eletrônica MS, unidade criada em 2016 em Campo Grande/MS pelo grupo Tesla/Fluxo. Após anos atuando com manutenção e representação autorizada Danfoss, a unidade se emancipou do grupo, dando origem à Centro Oeste Automação Industrial — uma marca independente, comprometida em oferecer soluções completas em automação e instrumentação industrial, com o respaldo de fabricantes líderes globais.</div>
  <div className="columnEMPRESA"><br/>Somos Revenda e Assistência Técnica Autorizada WEG Automação, especializados na linha de baixa tensão, com foco em inversores de frequência, soft starters, contatores, relés, disjuntores, botoeiras e demais componentes para painéis elétricos. Mantemos estoque próprio e uma equipe técnica preparada para orientar nossos clientes na seleção, aplicação e parametrização dos equipamentos, garantindo agilidade e confiabilidade em cada projeto.</div>
  <div className="espacob2"/>
  <div className="columnEMPRESA"><br/>Além das soluções comerciais e de suporte técnico, promovemos treinamentos presenciais e práticos voltados à parametrização, manutenção e diagnóstico de inversores e soft starters WEG, capacitando equipes de manutenção e engenheiros de todo o Centro-Oeste brasileiro.</div>
  <div className="espacob2"/>
  <div className="columnEMPRESA"><br/>Representamos também a CONAUT/KROHNE, referência internacional em instrumentação de processo, oferecendo ao mercado do Mato Grosso do Sul e Mato Grosso equipamentos de medição de vazão, nível e análises de processo, amplamente aplicados em indústrias e sistemas de saneamento.</div>
  <div className="espacob2"/>
  <div className="columnEMPRESA"><br/>Com atuação sólida nos segmentos industrial e de saneamento, a Centro Oeste Automação Industrial une tecnologia, conhecimento e suporte técnico especializado para entregar soluções completas em automação e instrumentação — com a qualidade e confiança das marcas WEG e CONAUT/KROHNE.</div>
  
  <div className="espacob2"/>
  <div className="espacob3"/>
  <div className="espaco"></div>
  <ButtonE1/>
  <div className="espaco"></div>
  <ButtonE2/>
  <div className="espaco"></div>
  <Footer/>
   <FooterContatos/>
   <FloatingWhatsApp avatar={LOGOL} position="absolute" accountName="Centro Oeste" allowClickAway="true" placeholder="Escreva sua mensagem"  chatMessage="Olá, como posso te ajudar?" statusMessage="online" allowEsc="true" phoneNumber="5567998383492"/>
</div>
 );
 }
}
export default Empresa;